/*globals dashboardApp,WidgetDirective*/
import icon from './image.png.js';
import template from './image_widget_view.html';
import templateEditView from './image_widget_edit.html';
import templateMaxView from './image_widget_max.html';

angular
    .module('MW.Dashboard.ImageWidget', ['MW.Dashboard.DashboardWidgetService', 'MW.Framework.WidgetStatus', 'MW.Framework.AppChromeService', 'MW.Framework.DataExportService', 'MW.Configuration'])
    .run(['DashboardWidgetService', 'DASHBOARD_LEGACY_URL', function(DashboardWidgetService, DASHBOARD_LEGACY_URL) {
    DashboardWidgetService.register({
        name: 'Image',
        app: 'dashboard',
        defaultTitle: '',
        description: 'The Image widget displays a photo or image file inside the widget container. It can be used to display a logo or image relating to the content of the dashboard. Acceptable file formats include jpg, png and gif images.',
        directive: 'image-widget',
        icon,
        defaultSettings: {
            imageSrc: '',
            imageTitle: '',
            width: 'third'
        },
        displayOrder: 99,
        availableFilters : [],
        availableSettings : ['title'],
        hasCustomSettings: true,
        requiredSettings: ['imageSrc'],
        reportAs: 'html',
        template,
        templateEditView,
        templateMaxView,
        hasRequiredSettings: function hasRequiredSettings() {
            if(typeof this['settings'] === 'undefined') {
                return false;
            } else if (this.settings.imageSrc !== 'undefined' && this.settings.imageSrc !== '') {
                return true;
            } else {
                return false;
            }
         }
    });

}]);

angular
    .module('MW.Dashboard.ImageWidget')
    .directive('imageWidget', ['DashboardWidgetService', function(DashboardWidgetService){
    var imageWidget = DashboardWidgetService.getWidget('image-widget');

    return new WidgetDirective(imageWidget);
}]);
